import Button from '@mui/material/Button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@tyro/core';
import { useTranslation } from '@tyro/i18n';

export function AddQuickActionNoPermissionModal({
  open,
  onClose,
}: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation(['common']);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('common:addQuickAction')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('common:addQuickActionNoPermissionMessage')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="soft" color="inherit" onClick={onClose}>
          {t('common:actions.back')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
